import fetchClient from './index';
import {VITE_FAQ_URL} from './urls';

export default async function getFAQ() {
  try {
    const response = await fetchClient().get(`${VITE_FAQ_URL}/faq`);
    return response;
  } catch (e) {
    console.log('errorrr', e);
    return e;
  }
}
